export class InternalApiClient {
  private static instance: InternalApiClient

  private constructor() { }

  public static getInstance(): InternalApiClient {
    if (!InternalApiClient.instance) {
      InternalApiClient.instance = new InternalApiClient()
    }

    return InternalApiClient.instance
  }


public async post<T>( body: any): Promise<T> {
    try {
    //   const isFormData = body instanceof FormData;
      const response = await fetch('/api/forms', {
        method: 'POST',
        body: body,
      });

      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.status} - ${response.statusText}`);
      }

      const data = await response.json();
      console.log('Response from internal API:', data);
      return data;
    } catch (error) {
      console.error('Error posting data to ', error);
      throw error;
    }
  }}